import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: 'Home',
	component: () => import('../views/Home.vue')
}, {
	path: '/news1',
	name: 'News1',
	component: () => import('../views/News1.vue')
}, {
	path: '/news2',
	name: 'News2',
	component: () => import('../views/News2.vue')
}, {
	path: '/news3',
	name: 'News3',
	component: () => import('../views/News3.vue')
}, {
	path: '/details',
	name: 'Details',
	component: () => import('../views/Details.vue')
}, {
	path: '/search',
	name: 'Search',
	component: () => import('../views/Search.vue')
}, {
	path: '/login',
	name: 'Login',
	component: () => import('../views/Login.vue')
}, {
	path: '/register',
	name: 'Register',
	component: () => import('../views/Register.vue')
}, {
	path: '/userinfo',
	name: 'Userinfo',
	component: () => import('../views/Userinfo.vue')
}]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})
router.beforeEach((to, from, next) => {
	if (to.path != '/') {
		document.body.scrollTop = 0
		// firefox
		document.documentElement.scrollTop = 0
	} else {
		document.body.scrollTop = 0
		// firefox
		document.documentElement.scrollTop = 0
	}
	next()
})
export default router